import { computed, ref } from "@vue/composition-api";
import { TwitterAutoPostingSettings } from "@scrile/api-provider/dist/api/TwitterAutoPostingProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export default function useAutoPostingToX() {
  const { authUser, authorities } = useAuthUser();
  const settings = ref<TwitterAutoPostingSettings>();
  const loading = ref(false);

  const hasAuthorities = computed(() =>
    checkAuthorities(authorities.value, ["getMyTwitterAutoPosting", "updateMyTwitterAutoPosting"])
  );

  const fetchSettings = async () => {
    if (!authUser.value || !hasAuthorities.value) return;
    loading.value = true;
    try {
      settings.value = await providers.TwitterAutoPostingProvider.settingsSearch({ userId: authUser.value.id });
    } finally {
      loading.value = false;
    }
  };

  const allowSetupAutoPostingSettings = computed(() => {
    if (!authUser.value || !hasAuthorities.value) return false;
    return settings.value?.allowed === true;
  });

  const allowSetupAutoPostingInPosts = computed(() => {
    if (!authUser.value || !hasAuthorities.value) return false;
    return settings.value?.allowed === true && settings.value?.enabled === true;
  });

  return {
    settings,
    loading,
    hasAuthorities,
    allowSetupAutoPostingSettings,
    allowSetupAutoPostingInPosts,
    fetchSettings,
  };
}
